import { useState } from 'react';
import { useMachineState, useUnitIdentity } from '../app/context';
import { cx } from '../components/cx';
import { UserIcon } from '../components/icons';
import common from './common.module.css';
import styles from './WelcomeScreen.module.css';

function shiftLabel(date: Date): string {
  const hour = date.getHours();
  return hour >= 7 && hour < 19 ? 'DAY · 07:00–19:00' : 'NIGHT · 19:00–07:00';
}

export function WelcomeScreen() {
  const { operator } = useMachineState();
  const { hospitalName, unitId } = useUnitIdentity();
  // Captured once: this is the time the operator signed in, not a live clock.
  const [loginAt] = useState(() => new Date());

  return (
    <section className={cx(common.screen, common.fadeUp, styles.screen)} aria-label="Welcome">
      <div className={cx(common.kicker, common.reveal)}>{hospitalName.toUpperCase()}</div>
      <div className={styles.avatar} aria-hidden>
        <div className={styles.avatarRing} />
        <UserIcon size={36} />
      </div>
      <div className={styles.greeting}>
        <div className={styles.salutation}>WELCOME, OPERATOR</div>
        <h1 className={styles.name}>{operator?.name.toUpperCase()}</h1>
      </div>
      <dl className={cx(common.card, styles.facts)}>
        <div className={styles.fact}>
          <dt className={common.fieldLabel}>SHIFT</dt>
          <dd>{shiftLabel(loginAt)}</dd>
        </div>
        <div className={styles.fact}>
          <dt className={common.fieldLabel}>UNIT</dt>
          <dd>{unitId}</dd>
        </div>
        <div className={styles.fact}>
          <dt className={common.fieldLabel}>LOGIN</dt>
          <dd>{loginAt.toTimeString().slice(0, 8)}</dd>
        </div>
      </dl>
      <div className={styles.footnote}>ESTABLISHING UPLINK…</div>
    </section>
  );
}
